import React from "react";
import { ConfirmationModalContainer } from "../Modal/ConfirmationModalContainer";
import { getValue } from "../../utils/object.utils";
interface Props {
  open: boolean;
  onClose: () => unknown;
  handleTransportRemove: () => unknown;
  selectedTransportToRemove: any;
  isProcessingConfirmation: boolean;
}

export const RemoveTransportModal = ({
  open,
  onClose,
  handleTransportRemove,
  selectedTransportToRemove,
  isProcessingConfirmation,
}: Props) => {
  const transportCode = getValue(
    selectedTransportToRemove,
    "transportCode",
    ""
  );
  return (
    <ConfirmationModalContainer
      show={open}
      onClose={onClose}
      onSubmit={handleTransportRemove}
      isRemoving
      isProcessingConfirmation={isProcessingConfirmation}
    >
      <div>Do you want to remove transport {transportCode} ?</div>
    </ConfirmationModalContainer>
  );
};
